<template>
  <lottie-player
    ref="lottie"
    :class="[
      { 'opacity-0': hideLottie && showLottieOnlyWhenElHidden },
      'duration-500'
    ]"
    v-if="formattedContent"
    :src="formattedContent"
    background="transparent"
    :speed="speed"
    v-bind="{
      ...(loop ? { loop } : {})
    }"
    autoplay
  ></lottie-player>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LottieComponent',
  props: {
    loop: {
      type: Boolean,
      default: false
    },
    src: {
      type: [String, Object],
      default: ''
    },
    content: {
      type: [String, Object],
      default: ''
    },
    elToHide: {
      type: String,
      default: ''
    },
    showLottieOnlyWhenElHidden: {
      type: Boolean,
      default: true
    },
    speed: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      elHidden: false,
      tryToHideInterval: 0
    };
  },
  mounted() {
    this.loadLottiePlayer();
    this.tryToHideEl();
  },
  methods: {
    loadLottiePlayer() {
      const scriptSelector = 'script[name="lottieScript"]';
      const lottieScriptAlreadyAdded = document.querySelector(scriptSelector);
      if (lottieScriptAlreadyAdded) return;
      const lottieScript = document.createElement('script');
      lottieScript.setAttribute('name', 'lottieScript');
      lottieScript.setAttribute(
        'src',
        'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js'
      );
      document.head.appendChild(lottieScript);
    },
    tryToHideEl() {
      if (!this.elToHide) return;
      if (this.elHidden) {
        clearInterval(this.tryToHideInterval);
        return;
      }
      if (!this.tryToHideInterval)
        this.tryToHideInterval = setInterval(this.tryToHideEl, 500);
      const lottie = this.$refs.lottie;
      const shadowRoot = lottie?.shadowRoot;
      if (!shadowRoot) return;
      const targedTag = shadowRoot.querySelector(this.elToHide);
      if (!targedTag) return;
      targedTag.style.display = 'none';
      targedTag.style.opacity = 0;
      targedTag.style.pointerEvents = 'none';
      this.elHidden = true;
    }
  },
  computed: {
    hideLottie() {
      if (!this.elToHide) return false;
      return !this.elHidden;
    },
    formattedContent() {
      if (!this.src && !this.content) return '';
      return JSON.stringify(this.src);
    }
  }
});
</script>
